import { render, staticRenderFns } from "./CandidateCard.vue?vue&type=template&id=71acf023&scoped=true"
import script from "./CandidateCard.vue?vue&type=script&lang=js"
export * from "./CandidateCard.vue?vue&type=script&lang=js"
import style0 from "./CandidateCard.vue?vue&type=style&index=0&id=71acf023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71acf023",
  null
  
)

export default component.exports